import ForbiddenPage from "./Forbidden";
export default ForbiddenPage